import { useEffect, useState, type ReactNode } from 'react';

import { loadSession } from '../auth/session.js';
import { setSentryUser } from '../lib/sentry.js';
import { LoginPage } from '../pages/Login.js';

export const AuthGate = ({ children }: { children: ReactNode }) => {
  const [authed, setAuthed] = useState<boolean>(() => loadSession() !== null);

  // Sincroniza la identidad del usuario con Sentry cada vez que la auth
  // cambia — al login, al refresh de sesión, o al mount con sesión existente.
  useEffect(() => {
    if (!authed) return;
    const s = loadSession();
    if (s) setSentryUser(s.user.id, s.tenantId, s.user.role);
  }, [authed]);

  if (!authed) return <LoginPage onLogin={() => setAuthed(true)} />;
  return <>{children}</>;
};
